// AUTO-GENERATED by scripts/build-registry.js: study entry for meteorology/gfa-clouds-weather-symbols.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/meteorology/gfa-clouds-weather-symbols/gfa-clouds-weather-symbols.js';

mount([g0]);
